export const redirectPage = (redirectLink: string) => {
    window.location.href = redirectLink
}
export const redirectToNewPage = (redirectLink: string) => {
    window.open(redirectLink, '_blank');
}
